export const IBAN_COUNTRY_CODES = [
  'AUT',
  'BEL',
  'CHE',
  'DEU',
  'DNK',
  'ESP',
  'FRA',
  'GBR',
  'ITA',
  'NLD',
  'NOR',
  'SWE',
];

export const isIbanCountry = (country?: string) =>
  !!country && IBAN_COUNTRY_CODES.includes(country);
